
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'cardForm': {'display': `flex`,'flexDirection': `column`,},'fullWidthInput': {'width': `100%`,'margin': `8px 0`,},'dividedColumn': {'display': `flex`,'justifyContent': `space-between`,},'halfWidthInput': {'margin': `8px 0`,'width': `240px`,},'saveCardButton': {'width': `50%`,},'halfWidthEnd': {'display': `flex`,'justifyContent': `flex-end`,},
        
      };
    };
  